import { render, staticRenderFns } from "./ConsumablesOrders.vue?vue&type=template&id=d420e7d6&scoped=true"
import script from "./ConsumablesOrders.vue?vue&type=script&lang=js"
export * from "./ConsumablesOrders.vue?vue&type=script&lang=js"
import style0 from "./ConsumablesOrders.vue?vue&type=style&index=0&id=d420e7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d420e7d6",
  null
  
)

export default component.exports